export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6992.9b931bf4.jpg";